import { plPL } from '@mui/material/locale';
import {
	createTheme,
	ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';
import React, { createContext, useState } from 'react';
import { setProperty } from 'utils/helper';

const defaultState = {
	theme: {
		typography: {
			// In Chinese and Japanese the characters are usually larger,
			// so a smaller fontsize may be appropriate.
			fontSize: 14,
			fontFamily: '"Segoe UI", "ui-sans-serif", sans-serif',
		},

		components: {
			MuiTableCell: {
				styleOverrides: {
					root: {
						fontFamily: '"Segoe UI", "ui-sans-serif", sans-serif',
						fontSize: '1rem',
					},
				},
			},

			 MuiCssBaseline: {
				styleOverrides: {
					'.MuiSvgIcon-root': {
						fontSize: '1rem !important',
					},
				},
			},

			MuiTablePagination: {
				styleOverrides: {
					select: {
						fontFamily: '"Segoe UI", "ui-sans-serif", sans-serif',
						fontSize: '1rem',
					},
				},
			},

			MuiTypography: {
				styleOverrides: {
					body2: {
						fontFamily: '"Segoe UI", "ui-sans-serif", sans-serif',
						fontSize: '1rem',
					},
				},
			},

			MuiTooltip: {
				styleOverrides: {
					popper: {},
				},
			},

			MuiPopover: {
				styleOverrides: {
					root: {},
				},
			},
		},

		palette: {
			primary: { main: '#006BFF' },
			secondary: { main: '#0A9E50' },
		},
	},

	setTheme: () => {},
	setPrimaryColor: () => {},
};

const Context = createContext(defaultState);

function ThemeProvider({ children }) {
	const [theme, updateTheme] = useState(
		createTheme(defaultState.theme, plPL)
	);

	const setTheme = (object) => {
		updateTheme(createTheme(object, plPL));
	};

	const setPrimaryColor = (value) => {
		setProperty('--color-primary', value);

		updateTheme(
			createTheme(
				{
					...defaultState.theme,
					palette: {
						...defaultState.theme.palette,
						primary: { main: value },
					},
				},
				plPL
			)
		);
	};

	return (
		<Context.Provider
			value={{
				theme,
				setTheme,
				setPrimaryColor,
			}}
		>
			<MuiThemeProvider theme={theme}>
				{/* <StyledEngineProvider injectFirst> */}
				{children}
				
				{/* </StyledEngineProvider> */}
			</MuiThemeProvider>
		</Context.Provider>
	);
}

export { ThemeProvider };
export default Context;
